import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Building2 } from 'lucide-react';
import { apiService } from '@/core/api/service';
import { useAppState } from '@/core/app-context';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function TenantSelector() {
  const { selectedTenant, selectTenant, clearTenant } = useAppState();
  const { data: tenants, isLoading } = useQuery({
    queryKey: ['tenants'],
    queryFn: () => apiService.listTenants(),
  });

  useEffect(() => {
    if (!tenants || tenants.length === 0 || !selectedTenant) return;
    const current = tenants.find((t) => t.tenantId === selectedTenant.tenantId);
    if (current) {
      if (current.name !== selectedTenant.name || current.dbName !== selectedTenant.dbName) {
        selectTenant(current);
      }
    }
  }, [tenants, selectedTenant, selectTenant]);

  return (
    <div className="flex items-center gap-2">
      <Building2 className="h-4 w-4 text-muted-foreground" />
      <Select
        value={selectedTenant?.tenantId ?? ''}
        onValueChange={(value) => {
          const tenant = tenants?.find((t) => t.tenantId === value);
          if (tenant) selectTenant(tenant);
          else clearTenant();
        }}
        disabled={isLoading && !selectedTenant}
      >
        <SelectTrigger className="w-[140px] sm:w-[180px]">
          <SelectValue
            placeholder={isLoading && !selectedTenant ? 'Caricamento...' : 'Seleziona tenant'}
            className="truncate"
          >
            {selectedTenant?.name}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {tenants?.map((tenant) => (
            <SelectItem key={tenant.tenantId} value={tenant.tenantId}>
              {tenant.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
